var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonSolidSquash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 699.998 400.002"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 59",
    d: "M438.998 400h-296.3c-37.971 0-56.957-32.939-56.957-32.939l-77.3-134.119c-18.986-32.934 0-65.873 0-65.873l77.3-134.119C104.727-.001 142.698-.001 142.698-.001h414.6c37.971 0 56.957 32.951 56.957 32.951l77.3 134.119c18.986 32.939 0 65.873 0 65.873l-77.3 134.119C595.269 400 557.298 400 557.298 400z",
    fill: "currentColor"
  })));
}
export default SvgHexagonSolidSquash;